export default "__VITE_ASSET__YmlR3UiY__"